














import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { dom } from '@fortawesome/fontawesome-svg-core';
import { FeedStateModule, UserStateModule } from '@/store/';
import { FeedModel } from '@/type';

@Component<FeedContentButtonsContainer>({})
export default class FeedContentButtonsContainer extends Vue {
  // PROPS
  @Prop({ type: Object, required: true })
  feed!: FeedModel.Read.Response.Feed;
  @Prop({
    type: Function,
    required: false,
    default: () => {
      /** NP */
    },
  })
  onChangeFeed!: () => void;

  // MUTATIONS
  get isMyFeed() {
    return UserStateModule.selfUser.member_id === this.feed.member_id;
  }

  // METHODS
  handleClickFavorite() {
    const newFav = !this.feed.my_favorite_flg;

    return (newFav
      ? FeedStateModule.setFavorite({
          requestBody: { module_type: 'topics', module_id: this.feed.topics_id },
        })
      : FeedStateModule.removeFavorite({
          requestBody: { module_type: 'topics', module_id: this.feed.topics_id },
        })
    )
      .then(() => {
        this.onChangeFeed();
        (this as any).$snack.success({ text: newFav ? 'いいね！しました。' : 'いいね！を外しました。', button: 'OK' });
      })
      .catch(() => (this as any).$snack.danger({ text: 'エラーが発生しました。', button: 'OK' }));
  }
  handleClickRemove() {
    if (window.confirm('記事を削除してもよろしいですか？')) {
      FeedStateModule.removeFeed({ topicsId: this.feed.topics_id })
        .then(() => (this as any).$snack.success({ text: '記事を削除しました。', button: 'OK' }))
        .catch(() => (this as any).$snack.danger({ text: 'エラーが発生しました。', button: 'OK' }));

      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    }
  }
  handleClickEdit() {
    const topics_id = `${this.feed.topics_id}` as string;
    this.$router.push({ name: 'postWithArguments', params: { topics_id } });
  }

  // LIFECYCLE HOOKS
  mounted() {
    dom.watch();
  }
}
